import React from 'react';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskRovoServiceAgent: LazyComponent<
	typeof import('@jira/spa-apps__project-settings-service-desk-rovo-service-agent/src/RovoServiceAgentView.tsx').default
> = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-rovo-service-agent", jiraSpaEntry: "async-project-settings-service-desk-rovo-service-agent" */ '@jira/spa-apps__project-settings-service-desk-rovo-service-agent/src/RovoServiceAgentView.tsx'
		),
	),
);

const ServicedeskRovoServiceAgentComponent = (): JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskRovoServiceAgent}
		pageId="project-settings-rovo-service-agent"
		shouldShowSpinner
	/>
);

export default ServicedeskRovoServiceAgentComponent;
